"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = function _default(_ref) {
  var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 1 : _ref$size;
  return _react.default.createElement("svg", {
    alt: "",
    className: className,
    height: 16 * size,
    viewBox: "0 0 13.1 13.1",
    width: 16 * size
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5,13C2.9,13,0,10.1,0,6.5S2.9,0,6.5,0S13,2.9,13,6.5S10.1,13,6.5,13z M6.1,3.5v4.3h0.9V3.5H6.1z M6.1,8.7 v0.9h0.9V8.7H6.1z"
  }));
};

exports.default = _default;